<template>
  <div class="regions-select-field">
    <label class="regions-select-field__label">
      <span>{{ label }}</span>
    </label>

    <loader v-if="isLoading"/>
    <template v-else>
      <div v-if="showEmptyText" class="regions-select-field__empty">
        {{ emptyText }}
      </div>

      <v-row
        class="regions-select-field__row"
        v-for="(item, key) in rows"
        :key="`rs-${key}-${item}`"
      >
        <v-col cols="7">
          <v-autocomplete
            v-model="rows[key]"
            :items="regions"
            label="Регион"
            persistent-hint
            outlined
            item-text="name"
            item-value="id"
            :rules="rules.required"
            :loading="loading"
            :disabled="loading || disabled"
            @input="syncValue"
          >
          </v-autocomplete>
        </v-col>

        <v-col cols="1">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="accent"
                elevation="1"
                icon
                small
                class="mb-2 mt-3"
                v-bind="attrs"
                v-on="on"
                @click="deleteItem(key)"
                :disabled="disabled"
              >
                <!-- eslint-disable-next-line -->
                <font-awesome-icon icon="times"/>
              </v-btn>
            </template>
            <span>Удалить</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row class="regions-select-field__add">
        <v-col cols="3">
          <v-btn
            type="button"
            :loading="isLoading"
            :disabled="disabled"
            @click.s.stop="addEmptyItem"
            block
          >
            <template v-if="showEmptyText">
              Выбрать
            </template>
            <template v-else>
              Добавить
            </template>
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
  import _ from 'lodash'
  import md5 from 'md5'
  import { mapGetters } from 'vuex'
  import rules from '@/mixins/rules'
  import Loader from '@/components/loader/Loader.vue'

  export default {
    name: 'RegionsSelectFields',
    components: { Loader },
    mixins: [rules],
    data () {
      return {
        rows: [],
        loadingRegions: false,
      }
    },
    props: {
      label: {
        type: String,
        default: 'Регионы',
      },
      value: {
        type: Array,
        default: () => [],
      },
      emptyText: {
        type: String,
        default: null,
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        regions: 'regions/getRegions',
      }),
      isLoading () {
        return this.loading || this.loadingRegions
      },
      showEmptyText () {
        return this.emptyText && _.isEmpty(this.rows) && !this.loading
      },
    },
    watch: {
      value (newValue) {
        this.rows = newValue
      },
    },
    methods: {
      getHash (item) {
        return md5(item)
      },
      addEmptyItem () {
        this.rows.push(null)
      },
      deleteItem (key) {
        this.rows.splice(key, 1)
      },
      syncValue () {
        this.search = ''
        this.$emit('input', this.rows)
      },
    },
    async created () {
      if (!this.regions || this.regions.length === 0) {
        this.loadingRegions = true
        await this.$store.dispatch('regions/fetchRegions')
        this.loadingRegions = false
      }
    },
  }
</script>

<style lang="less" scoped>
.regions-select-field {
  padding: 30px;
  border-radius: 4px;
  border: 1px solid rgba(0,0,0,0.38);
  position: relative;
  margin-bottom: 50px;

  &__label {
    position: absolute;
    top: 11px;
    left: -12px;
    background: white;
    padding: 0 5px;
    transform: translateY(-24px) scale(0.75);
    color: #999999;
    font-size: 16px;
  }
  &__row {
    padding-top: 5px;
    padding-bottom: 5px;

    ::v-deep {
      .col {
        padding-bottom: 0;
        padding-top: 0;
      }
    }
  }

  &__empty {
    font-size: 16px;
    color: black;
  }
}

.regions-select_search {
  margin-top: -8px;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;

  ::v-deep {
    .v-list-item__content {
      padding-bottom: 0;
    }
  }
}
</style>
